// extracted by mini-css-extract-plugin
export var actions = "_3t-0";
export var actionsContainer = "_3t-6";
export var border = "_3t-1";
export var childFullHeight = "_3t-d";
export var collapse = "_3t-2";
export var content = "_3t-8";
export var contentChild = "_3t-c";
export var fullscreen = "_3t-a";
export var headerContainer = "_3t-3";
export var headerRow = "_3t-5";
export var hidePadding = "_3t-9";
export var noScrollX = "_3t-e";
export var noScrollY = "_3t-f";
export var optOutTopPadding = "_3t-b";
export var pagePadding = "_3t-7";
export var profile = "_3t-g";
export var profileContainer = "_3t-h";
export var profileImage = "_3t-i";
export var profileMain = "_3t-j";
export var profileSubtitle = "_3t-l";
export var profileTitle = "_3t-k";
export var tabsWrapper = "_3t-4";
export var title = "_3t-m";